function TextBanner() {
    var PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    PrevSelectedDesktop.removeClass("selectedBannerDesktop")

    if ($("#AnoncementArea ul.desktopSlide li").length != PrevSelectedDesktop.index() + 1) {
        PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    var PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    PrevSelectedMobile.removeClass("selectedBannerMobile")

    if ($("#AnoncementArea ul.mobileSlide li").length != PrevSelectedMobile.index() + 1) {
        PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }
}

$(document).ready(function () {
    setInterval(TextBanner, 7000);

    //$(".UseLazyLoad").Lazy();
    //$(".c-home-products img.PImage").Lazy();
});